export default {
  /*按钮*/
  bt:{
    search:"搜索",
    query:"查询",
    operation:"操作",
    add:"新增",
    edit:"修改",
    delete:"删除",
    down:"下载",
    export:"导出",
    upload:"上传",
    proposal:"审批",
    confirm:"确定",
    close:"关闭",
  },
  /*公用字段或工具函数字段*/
  common:{
    startTime:"开始时间",
    endTime:"结束时间",
    creator:"创建人",
    updater:"更新人",
    createTime:"创建时间",
    updateTime:"更新时间",
    phone:"手机号",
    name:"姓名",
    email:"邮箱",
    idNumber:"身份证号码",
    status:"状态",
    remark:"备注",
  },
  active:{
    activeNo:"活动编号",
    activeName:"活动名称",
    activeTime:"活动时间",
    openTime:"开户时间",
    status:"活动状态",
    androidChannel:"android渠道",
    iosChannel:"ios渠道",
    review:"审核",
    disable:"禁用",
    enable:"启用",
    bonusDesc:"奖励描述",
    url:"链接地址",
    activeDescribe:"活动描述",
    userList:"黑名单",
    joinCustomerStatus:"参与用户状态",
    alwaysShow:"游客是否显示红包",
    limitType:"限时类型",
    limitDays:"限时天数",
    taskContent:"任务与奖励",
    name:"渠道名称",
    pkg:"渠道包名",
    os:"系统类型",
    pleaseInput:"请填充 ",
    valid:"数据检验",
    enter:"确定",
    startTimeError:"活动开始时间不能小于当前时间",
    taskContentComplete:"活动开始时间不能小于当前时间",
    taskContentRepeat:"请勿设置重复任务",
    customerNo:"账号",
    task:"任务",
    startTime:"活动开始时间",
    endTime:"活动结束时间",
    customerCreateStartTime:"开户开始时间",
    customerCreateEndTime:"开户结束时间",
    customerActivatedStartTime:"激活开始时间",
    customerActivatedEndTime:"激活结束时间",
    chineseName:"客户姓名",
    task1:"开通真实账户",
    task3:"完善资料",
    task4:"首次入金",
    task5:"累计交易1手外汇",
    task6:"累计交易1手商品",
    task7:"累计交易1手指数",
    task8:"累计交易1手数字货币",
    task9:"交易下单",
    task10:"累计交易1手股票",
    customerCreateTime:"用户开户时间",
    customerActivatedTime:"用户激活时间",
    customerStatus:"用户状态",
    amount:"奖励金额",
    amountCny:"奖励金额(人民币)",
    selectTask:"请选择任务",
    taskTitle:"任务标题",
    taskDescribe:"任务描述",
    rewardValue:"赠金额度($)",
    orderNo:"发放流水",
    taskName:"任务名称",
    platform:"平台",
  },
  pushMsg:{
    parent:"所属业务",
    appName:"应用名称",
    status:"状态",
    remark:"备注",
    appKey:"appKey",
    appSecret:"appSecret",
    createTime:"创建时间",
    updateTime:"更新时间",
    updater:"更新人",
    env:"推送环境",
    prd:"生产环境",
    dev:"开发环境",
    check:"切换环境",
    isStop:"确定暂停?",
    isEnable:"确定启用?",
    fabu:"+发布消息公告",
    releaseStatus:"同步到",
    msgTitle:"消息标题",
    business:"所属业务",
    platform:"推送平台",
    msgLanguage:"语言",
    pushTime:"推送时间",
    pushConfig:"推送配置",
    type:"消息类型",
    pushStatus:"推送状态",
    msgPlatform:"应用平台",
    channel:"渠道",
    targetUsers:"目标用户",
    users:"目标用户1",
    businessId:"所属业务",
    updateDate:"修改时间",
    fabuDate:"发布时间",
    push:"同步",
    pushMode:"推送方式",
    msgRemark:"消息描述",
    msgContent:"消息内容",
    fabudao:"发布到",
    fabuson:"发布人",
    yewu:"业务",
    createDate:"发布时间",
    createBy:"创建人",
  },
  quantityTask:{
    ctime:"創建時間",
    customerNumber:"賬號",
    activeTime:"激活時間",
    userName:"用戶名",
    phone:"手機號",
    taskType:"任務類型",
    taskName:"任務名",
    quantity:"金幣值",
    businessType:"業務類型",
    companyId:"公司ID",
    detail:"詳情",
    status:"狀態",
    startTime:"開始時間",
    endTime:"結束時間",
    businessTypeAlias:"業務組別名",
    utime:"更新時間",
    uname:"操作人",
    taskStep:"活動階段",
    taskId:"活動ID",
    name:"名稱",
    rule:"活動規則",
    illustrate:"說明",
    title:"標題",
    category:"活動種類",
    addtionalConfig:"额外奖励设置",
    awardStatus:"領取狀態",
    finishedStatus:"完成狀態",
    typeName:"活動類型",
    type:"類型",
    proposalId:"提案號",
    taskStatus:"啟/禁",
    balance:"餘額",
    setting:"设置",
    exrate:"兌換比例",
    maxEx:"免審批額度（每天）",
    gmt:"GTM時區",
    examount:"兌換總額",
    proposalType:"提案類型",
    acceptTime:"領取時間",
    gtsManagerFac:"兌換通道",
    dicesDetailList:'明细记录详情',
  }
};
